export default __webpack_public_path__ + "static/media/ic_eth_24.6b1d8a1d.svg";